// /home/w3d/web3reg-com/src/components/Footer.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUniversity, 
  faComments, 
  faGlobe, 
  faHandshake, 
  faLink, 
  faEnvelope, 
  faShield,
  faArrowUp
} from '@fortawesome/free-solid-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Function to handle X (Twitter) share
  const handleShareToX = (e) => {
    e.preventDefault();
    
    const tweetText = `✅ Zpost.ai - Decentralized social media
✅ BankSystem.co - Web3 banking
✅ .MyUrl - Top-level Web3 domain

Experience true ownership in the Web3 era! 👇`;

    const url = "https://web3reg.com";
    
    const shareUrl = `https://x.com/intent/post?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(url)}`;
    
    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=700');
  };

  // Function to handle back to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Effect to handle back to top button visibility
  React.useEffect(() => {
    const handleScroll = () => {
      const backToTop = document.querySelector('.back-to-top');
      if (!backToTop) return;
      
      if (window.scrollY > 500) {
        backToTop.style.opacity = '1';
        backToTop.style.visibility = 'visible';
        backToTop.style.transform = 'translateY(0)';
      } else {
        backToTop.style.opacity = '0';
        backToTop.style.visibility = 'hidden';
        backToTop.style.transform = 'translateY(20px)';
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Twitter Card Meta Tags - Added by Helmet */}
      <Helmet>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Web3Reg_eth" />
        <meta name="twitter:creator" content="@Web3Reg_eth" />
        <meta name="twitter:title" content="Web3Reg - Gateway to Decentralized Web" />
        <meta name="twitter:description" content="Decentralized identity, social media, and banking on the blockchain. Zpost.ai, BankSystem.co, .MyUrl domains." />
        <meta name="twitter:image" content="https://web3reg.com/web3reg-screenshot.png" />
        <meta name="twitter:image:alt" content="Web3Reg Dashboard - Decentralized Web Services" />
        <meta name="twitter:url" content="https://web3reg.com" />
      </Helmet>
      
      <footer>
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <img 
                  src="/web3.png" 
                  alt="Web3Reg Logo" 
                  style={{ 
                    width: '48px', 
                    height: '48px', 
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 0 8px rgba(255,215,0,0.4))'
                  }}
                />
                <h3 style={{ color: 'var(--gold)', margin: 0 }}>Web3Reg</h3>
              </div>
              <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Your gateway to decentralized identity, social media, and financial services.
                Experience true ownership in the Web3 era.
              </p>
            </div>
            
            <div className="footer-section">
              <h3>Projects</h3>
              <ul>
                <li><a href="https://banksystem.co" target="_blank" rel="noopener noreferrer" className="footer-link">BankSystem.co</a></li>
                <li><a href="https://zpost.ai" target="_blank" rel="noopener noreferrer" className="footer-link">Zpost.ai</a></li>
                <li><a href="https://www.namecheap.com/domains/registration/results/?domain=yourname.myurl&hns=true" className="footer-link">.MyUrl Domains</a></li>
                <li><a href="https://handshake.org" target="_blank" rel="noopener noreferrer" className="footer-link">Handshake</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Resources</h3>
              <ul>
                <li><a href="https://learn.namebase.io/starting-from-zero/how-to-access-handshake-sites" target="_blank" rel="noopener noreferrer" className="footer-link">Resolve Guide</a></li>
                <li><a href="https://ens.domains" target="_blank" rel="noopener noreferrer" className="footer-link">ENS Domains</a></li>
                <li><a href="https://ethereum.org" target="_blank" rel="noopener noreferrer" className="footer-link">Ethereum</a></li>
                <li><a href="https://hsd-dev.org/" target="_blank" rel="noopener noreferrer" className="footer-link">Handshake Docs</a></li>
                <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
              </ul>
            </div>

            {/* Share Section - Simple */}
            <div className="footer-section">
              <h3>Share</h3>
              <div style={{ marginTop: '1.5rem' }}>
                <a
                  href="#"
                  onClick={handleShareToX}
                  style={{
                    color: 'var(--text-secondary)',
                    textDecoration: 'none',
                    fontSize: '1rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = 'var(--gold)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'var(--text-secondary)';
                  }}
                >
                  share to <FontAwesomeIcon icon={faXTwitter} style={{ color: 'var(--gold)' }} />
                </a>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '1rem',
              width: '100%'
            }}>
              <div>
                <p style={{ marginBottom: '0.5rem' }}>
                  Copyright © 2026 Web3Reg - All Rights Reserved.
                </p>
                <p style={{ color: 'var(--gold)', fontWeight: 'bold' }}>
                  Powered by Web3
                </p>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
                <a href="https://x.com/Web3Reg_eth" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faXTwitter} />
                  <span>@Web3Reg_eth</span>
                </a>
                <Link to="/privacy" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faShield} />
                  <span>Privacy</span>
                </Link>
                <a href="https://banksystem.co" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faUniversity} />
                  <span>BankSystem</span>
                </a>
                <a href="https://zpost.ai" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faComments} />
                  <span>Zpost</span>
                </a>
                <a href="https://www.namecheap.com/domains/registration/results/?domain=yourname.myurl&hns=true" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faGlobe} />
                  <span>MyUrl</span>
                </a>
                <a href="https://handshake.org" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faHandshake} />
                  <span>Handshake</span>
                </a>
                <a href="https://learn.namebase.io/starting-from-zero/how-to-access-handshake-sites" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FontAwesomeIcon icon={faLink} />
                  <span>Resolve</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Back to Top Button */}
        <button 
          onClick={scrollToTop}
          className="back-to-top"
          style={{
            background: 'var(--card-bg)',
            border: '1px solid var(--border)',
            color: 'var(--gold)',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            zIndex: '1000',
            opacity: '0',
            visibility: 'hidden',
            transform: 'translateY(20px)',
            fontSize: '1.2rem',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--gold)';
            e.currentTarget.style.color = 'var(--black)';
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 6px 20px var(--gold-shadow)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'var(--card-bg)';
            e.currentTarget.style.color = 'var(--gold)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          aria-label="Back to top"
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      </footer>
    </>
  );
};

export default Footer;
